// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"56eb59f7","372":"beedd60b","466":"62cc4d97","762":"28a0e27d"}[chunkId] + ".chunk.js";
};